import $ from "jquery";

/**
 * Update class on popup when form submits to allow dynamic content
 */
$(() => {
  $(document).on("submit_success", () => {
    const popupClass = "join-the-jamu-group-popup";
    if ($(`.${popupClass}`).is(":visible")) {
      $(`.${popupClass}`).addClass(`${popupClass}--submitted`);
    }
  });
});
